/**
 * @generated SignedSource<<c06df83b56220673de49a968abaa8d64>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type ChangePasswordInput = {
  clientMutationId?: string | null;
  value: string;
};
export type ChangePasswordForm_ChangePasswordMutation$variables = {
  input: ChangePasswordInput;
};
export type ChangePasswordForm_ChangePasswordMutation$data = {
  readonly InfectopharmAuth: {
    readonly changePassword: {
      readonly clientMutationId: string | null;
    } | null;
  };
};
export type ChangePasswordForm_ChangePasswordMutation = {
  response: ChangePasswordForm_ChangePasswordMutation$data;
  variables: ChangePasswordForm_ChangePasswordMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": null,
    "args": null,
    "concreteType": "InfectopharmAuthMutations",
    "kind": "LinkedField",
    "name": "InfectopharmAuth",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": [
          {
            "kind": "Variable",
            "name": "input",
            "variableName": "input"
          }
        ],
        "concreteType": "ChangePasswordPayload",
        "kind": "LinkedField",
        "name": "changePassword",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "clientMutationId",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "ChangePasswordForm_ChangePasswordMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "ChangePasswordForm_ChangePasswordMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "9cdaa1a483d28a2d588e0101b9f6bdbf",
    "id": null,
    "metadata": {},
    "name": "ChangePasswordForm_ChangePasswordMutation",
    "operationKind": "mutation",
    "text": "mutation ChangePasswordForm_ChangePasswordMutation(\n  $input: ChangePasswordInput!\n) {\n  InfectopharmAuth {\n    changePassword(input: $input) {\n      clientMutationId\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "0aa485d113500cdac513f1970d2bd7e4";

export default node;
